import { ChevronDown, ChevronUp, LucideIcon } from "lucide-react";
import React from "react";
import styled from "styled-components";
import { Link as RawLink } from "wouter";

interface Props {
  icon?: LucideIcon;
  to: string;
  label: string;
  children?: React.ReactNode;
  action?: {
    icon: LucideIcon;
    onClick(): void;
  };
}

export function Item({ icon: Icon, to, label, action, children }: Props) {
  const [open, setOpen] = React.useState(true);
  const ToggleIcon = open ? ChevronUp : ChevronDown;
  return (
    <Wrapper>
      <Root $active={window.location.pathname === to}>
        <Link to={to}>
          {Icon && <Icon size={14} color="rgb(132, 156, 255)" />}
          <Label>{label}</Label>
        </Link>
        {(children || action) && (
          <ActionWrapper>
            {children && (
              <Action onClick={() => setOpen(!open)}>
                <ToggleIcon size={16} color="rgb(132, 156, 255)" />
              </Action>
            )}
            {action && (
              <Action onClick={action.onClick}>
                <action.icon size={16} color="rgb(132, 156, 255)" />
              </Action>
            )}
          </ActionWrapper>
        )}
      </Root>
      {open && children && <Children>{children}</Children>}
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const Children = styled.div`
  padding-left: 25px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 2px 0;
`;

const Root = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  &:hover:after {
    content: "";
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.125);
  }
  ${({ $active }) =>
    $active &&
    `
    &:after {
      content: "";
      pointer-events: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.125);
    }
    `}
`;

const ActionWrapper = styled.div`
  display: flex;
  padding-right: 5px;
`;

const Action = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
`;

const Link = styled(RawLink)`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 5px 0 5px 10px;
  font-weight: 300;
  text-decoration: none;
  flex-grow: 1;
`;

const Label = styled.div`
  color: #d5ddff;
  white-space: nowrap;
`;
